
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $556e2df49c597d88$exports = {};

$parcel$export($556e2df49c597d88$exports, "spectrum--large", function () { return $556e2df49c597d88$export$a88a8dbe29386d31; }, function (v) { return $556e2df49c597d88$export$a88a8dbe29386d31 = v; });
var $556e2df49c597d88$export$a88a8dbe29386d31;
$556e2df49c597d88$export$a88a8dbe29386d31 = `_1DrGeG_spectrum--large`;


export {$556e2df49c597d88$exports as default};
//# sourceMappingURL=vars_spectrum-large_css.mjs.map
